module.exports = __webpack_public_path__ + "static/media/Robot_error.adb613d9.webp";